/* unplugin-vue-components disabled */import script from "./GroupInvitationLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupInvitationLink.vue?vue&type=script&lang=ts&setup=true"

import "./GroupInvitationLink.vue?vue&type=style&index=0&id=af395c9e&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af395c9e"]])

export default __exports__